import { createSlice } from '@reduxjs/toolkit';
import { CatalogueState, FixMe } from '@greenkub-fronts/shared/interface';

export const CATALOGUE_FEATURE_KEY = 'catalogue';

export const initialCatalogueState: CatalogueState = {
  catalogueStatus: 'empty',
  isEditingBim: false,
  currentDirectory: null,
  catalogue: {
    studios: [],
    models: [],
    equipments: [],
    finishes: [],
    options: [],
    defaultOptionFinishEquipment: [],
  },
};

const catalogueSlice = createSlice({
  name: CATALOGUE_FEATURE_KEY,
  initialState: initialCatalogueState,
  reducers: {
    addCatalogue(state, action) {
      state.catalogue.studios = action.payload.studios;
      state.catalogue.models = action.payload.models;
      state.catalogue.equipments = action.payload.equipments;
      state.catalogue.finishes = action.payload.finishes;
      state.catalogue.options = action.payload.options;
    },
    addModels(state, action) {
      state.catalogue.models = action.payload;
    },
    addEquipment(state, action) {
      state.catalogue.equipments = action.payload;
    },
    addFinishes(state, action) {
      state.catalogue.finishes = action.payload;
    },
    addOptions(state, action) {
      state.catalogue.options = action.payload;
    },
    addDefaultOptionFinishEquipment(state, action) {
      state.catalogue.defaultOptionFinishEquipment = action.payload;
    },
    updateCatalogueStatus(state, action) {
      state.catalogueStatus = action.payload;
    },
    toggleEditingBimCatalogue(state) {
      state.isEditingBim = !state.isEditingBim;
    },
    selectCurrentDirectory(state, action) {
      state.currentDirectory = action.payload;
    },
  },
});

export const catalogue = catalogueSlice.reducer;

export const catalogueActions: FixMe = catalogueSlice.actions;
